import { render, staticRenderFns } from "./BuyerMobileRow.vue?vue&type=template&id=fa3c2ec2&scoped=true"
import script from "./BuyerMobileRow.vue?vue&type=script&lang=js"
export * from "./BuyerMobileRow.vue?vue&type=script&lang=js"
import style0 from "./BuyerMobileRow.vue?vue&type=style&index=0&id=fa3c2ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3c2ec2",
  null
  
)

export default component.exports